import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";

const SITE_URL = "https://honeybeeroofers.com";

export default function LegalPage({ doc }) {
  useEffect(() => {
    document.title = `${doc.title} | Honey Bee Roofing & Exteriors`;
    window.scrollTo(0, 0);
    const setMeta = (attr, key, content) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    setMeta("name", "description", `${doc.title} for Honey Bee Roofing & Exteriors.`);
    let c = document.head.querySelector('link[rel="canonical"]');
    if (!c) { c = document.createElement("link"); c.setAttribute("rel", "canonical"); document.head.appendChild(c); }
    c.setAttribute("href", `${SITE_URL}/${doc.slug}`);
  }, [doc]);

  return (
    <div className="bg-obsidian min-h-screen">
      <Header onQuote={() => {}} />
      <section className="pt-36 pb-20">
        <div className="max-w-3xl mx-auto px-5 sm:px-8">
          <Link to="/" className="inline-flex items-center gap-1.5 text-sm text-zinc-400 hover:text-honey mb-6 transition-colors">
            <ArrowLeft className="w-4 h-4" /> Back to home
          </Link>
          <h1 className="font-display font-black text-white text-4xl sm:text-5xl tracking-tight" data-testid="legal-title">{doc.title}</h1>
          <p className="text-sm text-zinc-500 mt-3">Last updated: {doc.updated}</p>
          <p className="text-[16px] text-zinc-300 leading-[1.8] mt-6">{doc.intro}</p>

          <div className="mt-10 space-y-8">
            {doc.sections.map((s, i) => (
              <div key={i}>
                <h2 className="text-xl font-display font-bold text-white mb-3">{s.h}</h2>
                {s.body.map((item, j) =>
                  typeof item === "string" ? (
                    <p key={j} className="text-[15px] text-zinc-400 leading-[1.8] mb-3">{item}</p>
                  ) : (
                    <ul key={j} className="list-disc pl-5 space-y-2 mb-3 text-[15px] text-zinc-400 leading-[1.7]">
                      {item.list.map((li, k) => <li key={k}>{li}</li>)}
                    </ul>
                  )
                )}
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
